import { Box, CircularProgress } from '@mui/material'
import { HlLogo } from '@ds/icons'

export const LoadingScreen = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: 80,
          height: 80,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 1,
        }}
      >
        <CircularProgress
          size={80}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            color: 'primary.main',
          }}
        />

        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            bgcolor: 'text.primary',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1,
            '& svg': {
              width: 32,
              height: 32,
            },
          }}
        >
          <HlLogo />
        </Box>
      </Box>
    </Box>
  )
}
